import { Link } from '@ontruck/orc';
import { usePOIVenueDetail, shouldShowVenueLink } from 'modules/point-of-interest';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const VenueLink = ({ gid, addressId, intl }) => {
  const { openModal, openCreationModal } = usePOIVenueDetail();
  const t = intl.messages.modules.poi.venue_link;
  const isPoiActive = useSelector((store) => getSpecificClientConfig(store, constants.POI));
  if (typeof gid === 'undefined' || !isPoiActive) {
    return null;
  }

  if (gid && shouldShowVenueLink(gid)) {
    return (
      <div>
        <Link text={t.details} onClick={() => openModal(gid, { addressId })} />
      </div>
    );
  }

  return (
    <div>
      <Link text={t.add} onClick={() => openCreationModal({ addressId })} />
    </div>
  );
};

export default injectIntl(VenueLink);
